import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Modal,
  Typography,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { set_show_popup } from "redux/actions/ScribeAcitons";
import { useSelector } from "react-redux";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { styled } from "@mui/system";
import CalendarSVG from "../../assets/images/CalendarSVG.svg";
import SupportContactForm from "./SupportContactForm";
import SupportContents from "./SupportContents";
import { useTranslation } from "react-i18next";
import CloseIcon from "@mui/icons-material/Close";
import CannyWidgetFR from "components/feedback/CannyWidget";
import Slide from "@mui/material/Slide";
import CommonProgress from "components/loader/commonProgress";
import HTTPRequest, { HTTPAidaBaseService } from "adapters/http";
import { getTenantFromToken } from "config/helpers/common_helper";
import { toast } from "react-toastify";

const ChatIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 1.41176C9.19183 1.41176 6.49867 2.52731 4.51299 4.51299C2.52731 6.49867 1.41176 9.19183 1.41176 12C1.41176 14.8082 2.52731 17.5013 4.51299 19.487C6.49867 21.4727 9.19183 22.5882 12 22.5882H19.1859C19.7925 22.5882 20.2152 22.5879 20.5469 22.5674C20.8723 22.5472 21.0637 22.5094 21.2107 22.4549C21.4952 22.3488 21.7535 22.1828 21.9681 21.9681C22.1828 21.7535 22.3488 21.4952 22.4549 21.2107C22.5094 21.0636 22.5472 20.8725 22.5674 20.5474C22.5879 20.2159 22.5882 19.7932 22.5882 19.1859V12C22.5882 9.19183 21.4727 6.49867 19.487 4.51299C17.5013 2.52731 14.8082 1.41176 12 1.41176ZM3.51472 3.51472C5.76516 1.26428 8.8174 0 12 0C15.1826 0 18.2348 1.26428 20.4853 3.51472C22.7357 5.76516 24 8.8174 24 12V19.2086C24 19.7879 24 20.2544 23.9764 20.6348C23.9521 21.026 23.901 21.372 23.7779 21.7033L23.7776 21.7041C23.6008 22.1781 23.3242 22.6086 22.9664 22.9664C22.6086 23.3242 22.1781 23.6008 21.7041 23.7776L21.7033 23.7779C21.3719 23.9011 21.0255 23.9522 20.6343 23.9764C20.2537 24 19.7872 24 19.2086 24H12C8.8174 24 5.76516 22.7357 3.51472 20.4853C1.26428 18.2348 0 15.1826 0 12C0 8.8174 1.26428 5.76516 3.51472 3.51472Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.05882 10.5882C7.05882 10.1984 7.37486 9.88235 7.76471 9.88235H16.2353C16.6251 9.88235 16.9412 10.1984 16.9412 10.5882C16.9412 10.9781 16.6251 11.2941 16.2353 11.2941H7.76471C7.37486 11.2941 7.05882 10.9781 7.05882 10.5882ZM11.2941 16.2353C11.2941 15.8454 11.6102 15.5294 12 15.5294H16.2353C16.6251 15.5294 16.9412 15.8454 16.9412 16.2353C16.9412 16.6251 16.6251 16.9412 16.2353 16.9412H12C11.6102 16.9412 11.2941 16.6251 11.2941 16.2353Z"
      fill="white"
    />
  </svg>
);

const CallIcon = () => (
  <svg
    width="19"
    height="24"
    viewBox="0 0 19 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.88183 6.9602C1.53198 4.68252 3.15666 2.6366 5.63855 1.88703C6.07899 1.75482 6.55382 1.79313 6.96674 1.99418C7.37966 2.19524 7.69978 2.544 7.86218 2.96974L8.65895 5.06998C8.78722 5.40785 8.81041 5.77591 8.72555 6.1269C8.6407 6.4779 8.45167 6.79582 8.18272 7.03986L5.81256 9.18537C5.69558 9.29124 5.60843 9.42532 5.55962 9.57449C5.51082 9.72366 5.50204 9.8828 5.53415 10.0363L5.55613 10.1305L5.61291 10.3659C5.90841 11.5092 6.35749 12.6084 6.94819 13.6339C7.59315 14.7228 8.39254 15.7148 9.32201 16.5797L9.39528 16.6449C9.5136 16.7487 9.65712 16.8204 9.81184 16.8531C9.96656 16.8858 10.1272 16.8783 10.2781 16.8313L13.3425 15.8772C13.6907 15.7691 14.0637 15.7663 14.4136 15.8692C14.7634 15.9721 15.0742 16.176 15.306 16.4547L16.7567 18.1947C17.3611 18.9189 17.2879 19.9835 16.5937 20.6226C14.6943 22.3734 12.0823 22.7319 10.2653 21.2889C8.03713 19.514 6.15939 17.3479 4.72639 14.8995C3.27937 12.4543 2.31541 9.76043 1.88183 6.9602ZM7.45372 10.1558L9.41726 8.37424C9.95546 7.88636 10.3339 7.25062 10.5039 6.54861C10.674 5.84661 10.6279 5.11039 10.3715 4.43448L9.57661 2.33423C9.25049 1.47743 8.60665 0.775458 7.77587 0.370909C6.9451 -0.0336396 5.98969 -0.110429 5.10371 0.156138C2.02104 1.08857 -0.453528 3.8207 0.0703246 7.23359C0.436655 9.61628 1.28105 12.6471 3.14384 15.812C4.68996 18.452 6.71547 20.7875 9.1187 22.7012C11.8442 24.8648 15.4819 24.1261 17.8447 21.9498C18.5208 21.3275 18.9312 20.4737 18.9921 19.5625C19.053 18.6514 18.7599 17.7516 18.1726 17.0468L16.7219 15.305C16.2578 14.7483 15.6361 14.3412 14.9364 14.136C14.2367 13.9309 13.491 13.937 12.7948 14.1535L10.2507 14.9447C9.59372 14.2753 9.01833 13.5321 8.53623 12.7304C8.07102 11.9197 7.70808 11.0557 7.45555 10.1576"
      fill="white"
    />
  </svg>
);

const TextIcon = () => (
  <svg
    width="24"
    height="21"
    viewBox="0 0 24 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.25526 1.28141C2.05898 0.460936 3.14907 0 4.28571 0H19.7143C20.8509 0 21.941 0.460936 22.7447 1.28141C23.5485 2.10188 24 3.21468 24 4.375V13.125C24 14.2853 23.5485 15.3981 22.7447 16.2186C21.941 17.0391 20.8509 17.5 19.7143 17.5V20.125C19.7143 20.4477 19.5403 20.7442 19.2616 20.8965C18.9829 21.0487 18.6447 21.032 18.3817 20.853L13.4548 17.5H4.28571C3.14907 17.5 2.05898 17.0391 1.25526 16.2186C0.451529 15.3981 0 14.2853 0 13.125V4.375C0 3.21468 0.451529 2.10188 1.25526 1.28141ZM4.28571 1.75C3.60373 1.75 2.94968 2.02656 2.46744 2.51884C1.9852 3.01113 1.71429 3.67881 1.71429 4.375V13.125C1.71429 13.8212 1.9852 14.4889 2.46744 14.9812C2.94968 15.4734 3.60373 15.75 4.28571 15.75H13.7143C13.8835 15.75 14.0489 15.8011 14.1897 15.897L18 18.49V16.625C18 16.1418 18.3838 15.75 18.8571 15.75H19.7143C20.3963 15.75 21.0503 15.4734 21.5326 14.9812C22.0148 14.4889 22.2857 13.8212 22.2857 13.125V4.375C22.2857 3.67881 22.0148 3.01113 21.5326 2.51884C21.0503 2.02656 20.3963 1.75 19.7143 1.75H4.28571Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.78782 8.38756C5.10931 8.05937 5.54534 7.875 6 7.875C6.45466 7.875 6.89069 8.05937 7.21218 8.38756C7.53367 8.71575 7.71429 9.16087 7.71429 9.625C7.71429 10.0891 7.53367 10.5342 7.21218 10.8624C6.89069 11.1906 6.45466 11.375 6 11.375C5.54534 11.375 5.10931 11.1906 4.78782 10.8624C4.46633 10.5342 4.28571 10.0891 4.28571 9.625C4.28571 9.16087 4.46633 8.71575 4.78782 8.38756ZM9.93067 8.38756C10.2522 8.05937 10.6882 7.875 11.1429 7.875C11.5975 7.875 12.0335 8.05937 12.355 8.38756C12.6765 8.71575 12.8571 9.16087 12.8571 9.625C12.8571 10.0891 12.6765 10.5342 12.355 10.8624C12.0335 11.1906 11.5975 11.375 11.1429 11.375C10.6882 11.375 10.2522 11.1906 9.93067 10.8624C9.60918 10.5342 9.42857 10.0891 9.42857 9.625C9.42857 9.16087 9.60918 8.71575 9.93067 8.38756ZM15.0735 8.38756C15.395 8.05937 15.8311 7.875 16.2857 7.875C16.7404 7.875 17.1764 8.05937 17.4979 8.38756C17.8194 8.71575 18 9.16087 18 9.625C18 10.0891 17.8194 10.5342 17.4979 10.8624C17.1764 11.1906 16.7404 11.375 16.2857 11.375C15.8311 11.375 15.395 11.1906 15.0735 10.8624C14.752 10.5342 14.5714 10.0891 14.5714 9.625C14.5714 9.16087 14.752 8.71575 15.0735 8.38756Z"
      fill="white"
    />
  </svg>
);

const WhatsappIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.9077 14.1918L15.1427 12.3094C15.0315 12.2541 14.9077 12.2291 14.7837 12.237C14.6598 12.2448 14.5401 12.2852 14.4367 12.3541L12.5919 13.5835C11.6579 13.1054 10.8981 12.3456 10.4199 11.4118L11.6506 9.56824C11.7195 9.46491 11.7599 9.34523 11.7678 9.2213C11.7756 9.09736 11.7506 8.97355 11.6953 8.86235L9.8128 5.09765C9.75426 4.97986 9.66399 4.88077 9.55214 4.81155C9.4403 4.74233 9.31134 4.70573 9.1798 4.70588C7.99402 4.70588 6.85681 5.17689 6.01834 6.01529C5.17987 6.85369 4.70882 7.9908 4.70882 9.17647C4.71193 11.8589 5.77899 14.4305 7.67591 16.3273C9.57283 18.224 12.1447 19.291 14.8274 19.2941C16.0131 19.2941 17.1504 18.8231 17.9888 17.9847C18.8273 17.1463 19.2983 16.0092 19.2983 14.8235C19.2984 14.6923 19.2619 14.5637 19.1929 14.4521C19.1239 14.3405 19.0251 14.2504 18.9077 14.1918ZM14.8274 17.8824C12.5191 17.8796 10.3061 16.9614 8.67392 15.3294C7.04171 13.6973 6.12351 11.4846 6.12071 9.17647C6.12077 8.43823 6.38785 7.72492 6.87267 7.16815C7.35748 6.61138 8.02731 6.24871 8.75859 6.14706L10.2481 9.12588L9.02567 10.9588C8.96144 11.0555 8.92204 11.1665 8.91096 11.282C8.89987 11.3976 8.91745 11.5141 8.96214 11.6212C9.61128 13.1644 10.8391 14.3921 12.3824 15.0412C12.4896 15.0859 12.6061 15.1034 12.7216 15.0924C12.8371 15.0813 12.9482 15.0419 13.0449 14.9776L14.878 13.7553L17.857 15.2447C17.7554 15.9759 17.3927 16.6457 16.8359 17.1305C16.279 17.6152 15.5657 17.8823 14.8274 17.8824ZM12.0036 2.6449e-07C9.92315 -0.000436437 7.87833 0.539915 6.06975 1.56804C4.26117 2.59617 2.75094 4.07675 1.68724 5.86454C0.623537 7.65233 0.0428982 9.6859 0.00228721 11.7658C-0.0383238 13.8456 0.462488 15.9003 1.45559 17.7282L0.0884098 21.8306C-0.00837927 22.1208 -0.0224256 22.4322 0.0478452 22.73C0.118116 23.0277 0.269927 23.3 0.486263 23.5163C0.702598 23.7326 0.974909 23.8844 1.27267 23.9547C1.57044 24.0249 1.88189 24.0109 2.17212 23.9141L6.27484 22.5471C7.88084 23.4185 9.66466 23.9118 11.4903 23.9892C13.3159 24.0667 15.135 23.7262 16.8091 22.9939C18.4831 22.2616 19.9679 21.1567 21.15 19.7635C22.3322 18.3704 23.1806 16.7256 23.6305 14.9548C24.0804 13.184 24.12 11.3338 23.7462 9.54536C23.3725 7.75691 22.5952 6.07741 21.4737 4.63494C20.3523 3.19246 18.9162 2.0251 17.275 1.22186C15.6338 0.418614 13.8308 0.000706894 12.0036 2.6449e-07ZM12.0036 22.5882C10.1422 22.5887 8.31351 22.0985 6.70194 21.1671C6.59448 21.1054 6.47288 21.0725 6.34896 21.0718C6.273 21.0722 6.19758 21.0845 6.12541 21.1082L1.7262 22.5741C1.68474 22.5879 1.64025 22.59 1.59771 22.5799C1.55517 22.5699 1.51627 22.5482 1.48536 22.5173C1.45446 22.4864 1.43277 22.4475 1.42273 22.405C1.41269 22.3624 1.4147 22.3179 1.42853 22.2765L2.89454 17.8824C2.92626 17.7874 2.93742 17.6868 2.92728 17.5872C2.91713 17.4876 2.88592 17.3913 2.83571 17.3047C1.66767 15.2872 1.19818 12.9406 1.50005 10.629C1.80193 8.31742 2.85831 6.17007 4.5053 4.5201C6.1523 2.87012 8.29783 1.80976 10.609 1.50352C12.9202 1.19728 15.2679 1.66229 17.2879 2.82639C19.3078 3.99049 20.887 5.78862 21.7806 7.9418C22.6742 10.095 22.8321 12.4829 22.2299 14.7349C21.6277 16.987 20.299 18.9775 18.45 20.3974C16.601 21.8174 14.335 22.5875 12.0036 22.5882Z"
      fill="white"
    />
  </svg>
);

const EmailIcon = () => (
  <svg
    width="24"
    height="16"
    viewBox="0 0 24 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.4847 8.03374L22.6359 2.65105V13.355L16.4847 8.03374ZM8.55836 8.94529L10.7184 10.8339C11.0575 11.124 11.4995 11.2992 11.9825 11.2992H11.9995H12.0125C12.4965 11.2992 12.9385 11.1229 13.2816 10.8308L13.2786 10.8329L15.4386 8.94429L22.0049 14.6241H1.99508L8.55836 8.94529ZM1.98608 1.37488H22.0169L12.3955 9.79137C12.2878 9.87842 12.1536 9.92538 12.0155 9.92433H12.0015H11.9885C11.8499 9.92532 11.7153 9.87799 11.6075 9.79037L11.6085 9.79137L1.98608 1.37488ZM1.36506 2.65005L7.51531 8.03273L1.36506 13.351V2.65005ZM22.966 0.191376C22.7259 0.0705068 22.4439 0 22.1449 0H1.85908C1.56935 0.00115512 1.28373 0.0690273 1.02404 0.198426L1.03504 0.19339C0.724896 0.347983 0.463716 0.586652 0.280866 0.882563C0.0980168 1.17847 0.000749392 1.51989 0 1.86843L0 14.1285C0.000529426 14.6247 0.196461 15.1004 0.544803 15.4513C0.893145 15.8021 1.36545 15.9995 1.85808 16H22.1419C22.6346 15.9995 23.1069 15.8021 23.4552 15.4513C23.8035 15.1004 23.9995 14.6247 24 14.1285V1.86843C24 1.13617 23.581 0.501605 22.971 0.196412L22.96 0.191376H22.966Z"
      fill="white"
    />
  </svg>
);

const ChatBotIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="24"
    viewBox="0 0 28 24"
    fill="none"
  >
    <path
      d="M10.5267 15.0889C10.6949 14.9207 10.9185 14.8281 11.1563 14.8281C11.3941 14.8281 11.6178 14.9209 11.7858 15.0889C11.914 15.2171 12.082 15.2812 12.25 15.2812C12.418 15.2812 12.5858 15.2171 12.714 15.0889C12.9704 14.8327 12.9704 14.4173 12.714 14.1609C12.2979 13.7449 11.7447 13.5156 11.1561 13.5156C10.5674 13.5156 10.0144 13.7449 9.59812 14.1609C9.34197 14.4173 9.34197 14.8327 9.59812 15.0889C9.85494 15.3453 10.2703 15.3453 10.5267 15.0889Z"
      fill="white"
    />
    <path
      d="M15.7767 15.0889C15.9449 14.9207 16.1685 14.8281 16.4063 14.8281C16.6441 14.8281 16.8678 14.9209 17.0358 15.0889C17.164 15.2171 17.332 15.2812 17.5 15.2812C17.668 15.2812 17.8358 15.2171 17.964 15.0889C18.2204 14.8327 18.2204 14.4173 17.964 14.1609C17.5479 13.7449 16.9947 13.5156 16.4061 13.5156C15.8174 13.5156 15.2644 13.7449 14.8481 14.1609C14.592 14.4173 14.592 14.8327 14.8481 15.0889C15.1049 15.3453 15.5203 15.3453 15.7767 15.0889Z"
      fill="white"
    />
    <path
      d="M25.5938 10.4688C26.6792 10.4688 27.5625 9.58566 27.5625 8.5V2.375C27.5625 1.28934 26.6792 0.40625 25.5938 0.40625H17.2812C16.1958 0.40625 15.3125 1.28934 15.3125 2.375V6.75H7.21875C5.40947 6.75 3.9375 8.22197 3.9375 10.0312V11.3438H1.75V4.78125C1.75 4.41878 1.45622 4.125 1.09375 4.125C0.731281 4.125 0.4375 4.41878 0.4375 4.78125V12.6562V14.625V16.5938C0.4375 17.3176 1.02616 17.9062 1.75 17.9062H3.9375V20.3125C3.9375 22.1218 5.40947 23.5938 7.21875 23.5938H20.3438C22.153 23.5938 23.625 22.1218 23.625 20.3125V17.9062H25.8125C26.5363 17.9062 27.125 17.3176 27.125 16.5938V12.6562C27.125 11.9324 26.5363 11.3438 25.8125 11.3438H23.625V10.4688H25.5938ZM16.625 2.375C16.625 2.01319 16.9194 1.71875 17.2812 1.71875H25.5938C25.9556 1.71875 26.25 2.01319 26.25 2.375V8.5C26.25 8.86181 25.9556 9.15625 25.5938 9.15625H20.125C19.9334 9.15625 19.7514 9.24003 19.6267 9.3855L18.8125 10.3355L17.9983 9.3855C17.8736 9.24003 17.6916 9.15625 17.5 9.15625H17.2812C16.9194 9.15625 16.625 8.86181 16.625 8.5V2.375ZM17.1137 10.4688C17.1303 10.4688 17.1458 10.465 17.1623 10.4639C17.1738 10.4646 17.185 10.4666 17.1968 10.4672L18.3144 11.771C18.4389 11.9162 18.6209 12 18.8125 12C19.0041 12 19.1861 11.9162 19.3108 11.7708L19.9062 11.076V19.875H7.65625V10.4688H17.1137ZM1.75 16.5938V14.625V12.6562H3.9375V16.5938H1.75ZM25.8125 12.6562L25.8134 16.5938H23.625V12.6562H25.8125ZM22.3125 20.3125C22.3125 21.3982 21.4292 22.2812 20.3438 22.2812H7.21875C6.13331 22.2812 5.25 21.3982 5.25 20.3125V10.0312C5.25 8.94559 6.13331 8.0625 7.21875 8.0625H15.3125V8.5C15.3125 8.73034 15.3543 8.95063 15.4273 9.15625H7.4375C6.83441 9.15625 6.34375 9.64691 6.34375 10.25V20.0938C6.34375 20.6968 6.83441 21.1875 7.4375 21.1875H20.125C20.7281 21.1875 21.2188 20.6968 21.2188 20.0938V10.4688H22.3125V20.3125Z"
      fill="white"
    />
    <path
      d="M18.8125 6.09375C19.1749 6.09375 19.4688 5.79994 19.4688 5.4375C19.4688 5.07506 19.1749 4.78125 18.8125 4.78125C18.4501 4.78125 18.1562 5.07506 18.1562 5.4375C18.1562 5.79994 18.4501 6.09375 18.8125 6.09375Z"
      fill="white"
    />
    <path
      d="M21.4375 6.09375C21.7999 6.09375 22.0938 5.79994 22.0938 5.4375C22.0938 5.07506 21.7999 4.78125 21.4375 4.78125C21.0751 4.78125 20.7812 5.07506 20.7812 5.4375C20.7812 5.79994 21.0751 6.09375 21.4375 6.09375Z"
      fill="white"
    />
    <path
      d="M24.0625 6.09375C24.4249 6.09375 24.7188 5.79994 24.7188 5.4375C24.7188 5.07506 24.4249 4.78125 24.0625 4.78125C23.7001 4.78125 23.4062 5.07506 23.4062 5.4375C23.4062 5.79994 23.7001 6.09375 24.0625 6.09375Z"
      fill="white"
    />
  </svg>
);

const FeatureReqIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_23953_20213)">
      <path
        d="M19.2106 21.2214C19.1904 21.2106 19.0936 21.1639 19.0842 21.1639H16.6422V12.5785C16.6422 12.0269 16.0214 11.4453 15.4851 11.3894C15.2254 11.3625 15.0072 11.4096 14.7621 11.4801C14.7059 11.4153 14.7004 11.3222 14.6637 11.2508C14.2839 10.5112 13.3869 10.2321 12.6498 10.6307C12.6256 10.6262 12.4955 10.3948 12.4614 10.35C12.1243 9.90676 11.5741 9.69638 11.0215 9.80748C10.9673 9.81828 10.7372 9.90737 10.7153 9.89127C10.6947 9.87496 10.6969 9.85253 10.6945 9.8297C10.6615 9.51882 10.6955 9.16165 10.6945 8.85199C10.6914 7.94135 10.8973 6.89147 9.92297 6.40262C8.99236 5.93578 7.90857 6.54695 7.81305 7.56706L7.80385 14.7684C7.7793 14.8179 7.69626 14.8208 7.65106 14.7978C7.1197 14.4373 6.61758 13.9581 6.08335 13.6109C4.82509 12.7936 3.29542 13.9611 3.77872 15.3784C3.90021 15.7349 4.33729 16.203 4.57311 16.5216C5.28057 17.4777 5.97393 18.4939 6.71125 19.4215C7.29068 20.1507 7.91511 20.5215 8.58474 21.1174C8.59824 21.1294 8.6238 21.1158 8.61092 21.1639H5.78044C5.76694 21.1639 5.64975 21.222 5.62848 21.2365C5.30389 21.4587 5.42824 21.9661 5.82155 21.9989L19.0032 21.9999C19.4321 22.0079 19.5896 21.4218 19.2104 21.2214H19.2106ZM15.8044 21.1639H9.97001C9.3554 20.6498 8.69682 20.1792 8.09039 19.6561C7.68133 19.3033 7.41463 18.9589 7.09086 18.5343C6.28726 17.4797 5.44542 16.3732 4.67905 15.296C4.20598 14.6312 4.92183 13.8741 5.60148 14.295C6.1398 14.6286 6.64846 15.1566 7.18187 15.4899C7.80364 15.8786 8.55938 15.5156 8.65264 14.7994L8.65121 7.64861C8.71114 6.8876 9.85302 6.85682 9.87388 7.75115C9.89106 8.48423 9.82971 9.23892 9.8565 9.97057C9.92502 11.1375 9.76917 12.4014 9.85691 13.5571C9.89802 14.1004 10.4476 14.2282 10.6859 13.7503C10.7497 12.9361 10.6341 12.0611 10.6947 11.2539C10.754 10.4645 11.7253 10.3777 11.9124 11.1212L11.9216 14.2488C12.0086 14.739 12.6718 14.7397 12.7541 14.2435C12.8177 13.4637 12.688 12.5932 12.7586 11.8241C12.8236 11.1169 13.9033 11.1026 13.9659 11.8243L13.9655 15.1447C14.0148 15.6334 14.6478 15.6925 14.7981 15.242L14.8024 12.7C14.8441 12.2179 15.4201 12.0361 15.713 12.4252C15.742 12.464 15.8044 12.5989 15.8044 12.6397V21.1639Z"
        fill="white"
      />
      <path
        d="M20.9187 6.127C20.3308 7.92994 18.6238 9.23953 16.7146 9.33066C15.2696 9.39956 13.77 9.27643 12.3192 9.33066C11.7819 9.28193 11.8061 8.57332 12.2841 8.49952C12.5522 8.45814 12.9948 8.49483 13.2797 8.49381C14.3934 8.48974 15.6079 8.5564 16.7146 8.49544C17.9718 8.42634 19.1556 7.68062 19.7854 6.60648C21.2516 4.10553 19.5291 1.00482 16.6739 0.835009H5.33028C2.71885 0.986885 0.984856 3.63584 1.95964 6.09071C2.48364 7.41071 3.81676 8.40717 5.24969 8.49442C5.5708 8.514 6.25863 8.43265 6.51736 8.53458C6.90699 8.68789 6.82211 9.2907 6.37419 9.33066C4.61811 9.48702 2.95999 8.94903 1.85922 7.55565C-0.487752 4.5846 1.49659 0.277657 5.21451 0.00693123L16.735 0C19.7937 0.197336 21.8769 3.18816 20.9187 6.127Z"
        fill="white"
      />
      <path
        d="M14.0579 3.17919L5.24929 3.17858C4.78194 3.09031 4.74042 2.50054 5.19284 2.34805L14.1185 2.34316C14.6366 2.43857 14.5815 3.15126 14.0579 3.17919Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_23953_20213">
        <rect width="22" height="22" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const RaiseTicketIcon = () => (
  <svg
    width="18"
    height="22"
    viewBox="0 0 18 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.9975 6.66724C17.9835 6.59001 17.7765 6.37152 17.7105 6.29457C16.3566 4.72333 14.8785 3.17023 13.4753 1.6328C13.0053 1.11803 12.5256 0.610685 12.0696 0.0827256L11.8211 0.000824508L1.22488 0C0.520112 0.0478214 0.0335734 0.507897 0 1.22274L0.000550383 20.8485C0.0371509 21.3919 0.421869 21.8714 0.962895 21.9759C1.21002 22.0234 1.42302 21.9858 1.66546 21.9871C6.78209 22.0135 11.9009 21.9786 17.0143 21.9803C17.5484 21.8918 17.9458 21.435 18 20.9035L17.9975 6.66724ZM12.1648 1.12793L16.9807 6.43226H12.1648V1.12793ZM17.3671 20.876C17.3401 21.1731 17.1183 21.3487 16.8304 21.3844H1.16984C0.921066 21.3693 0.735862 21.1915 0.64725 20.9719L0.633216 1.16805C0.609274 0.966873 0.901803 0.633222 1.08838 0.633222H11.5594V6.85825C11.5594 6.93466 11.7611 7.0685 11.8478 7.04954L17.3662 7.03662C17.3679 7.90263 17.3638 8.76919 17.3646 9.63547C17.3676 12.5636 17.3731 15.4991 17.3651 18.4272C17.3632 19.1929 17.4345 20.135 17.3671 20.876Z"
      fill="white"
    />
    <path
      d="M11.6136 13.1253C11.5479 13.0478 11.4345 13.005 11.4268 12.9962C11.4163 12.9841 11.3863 12.7403 11.3704 12.6812C11.2771 12.3382 11.1362 12.0538 10.9105 11.78C9.61573 10.2102 7.20258 10.8 6.69678 12.748C6.68412 12.7964 6.66431 12.9865 6.65605 12.9962C6.64119 13.0132 6.52203 13.0591 6.44553 13.1567C5.01894 14.9777 5.89184 18.3131 8.19602 18.9846C9.88872 19.4776 11.874 17.7604 12.2336 16.1615C12.4375 15.2561 12.2298 13.8504 11.6136 13.1253ZM8.72494 18.4701C6.54184 18.0751 5.7947 15.3666 6.88116 13.6055H8.72494V18.4701ZM7.29394 12.9734C7.63683 11.0292 10.4482 11.0344 10.7889 12.9734H7.29394ZM11.618 16.0688C11.353 17.1187 10.3808 18.0433 9.35788 18.3601V13.6055H11.2017C11.6216 14.3431 11.8302 15.2287 11.618 16.0688Z"
      fill="white"
    />
    <path
      d="M10.0596 6.81703L2.04219 6.79889C1.71912 6.65735 1.74719 6.23822 2.0854 6.13626L10.0602 6.12939C10.4724 6.18546 10.4754 6.76948 10.0596 6.81703Z"
      fill="white"
    />
    <path
      d="M10.2814 4.66204C10.2162 4.74752 10.1138 4.77912 10.0057 4.78434H2.18805C1.73729 4.77143 1.67867 4.20224 2.10604 4.0956H10.0877C10.3621 4.16376 10.4554 4.43393 10.2814 4.66204Z"
      fill="white"
    />
    <path
      d="M10.1436 2.72335C8.48965 2.7676 6.81979 2.75358 5.15984 2.75083C5.08141 2.75056 5.01371 2.72088 4.94216 2.72088C4.06595 2.71923 3.05049 2.82669 2.18804 2.75056C1.83938 2.71978 1.68087 2.34188 1.93652 2.12613C1.98495 2.08545 2.06861 2.06154 2.13273 2.06099L10.0877 2.06182C10.4309 2.1352 10.4757 2.5895 10.1436 2.72335Z"
      fill="white"
    />
    <path
      d="M14.5235 18.8763C14.3243 18.8304 14.0628 18.1672 13.947 17.9822L12.3478 17.4216C12.0322 17.227 12.2246 16.779 12.5848 16.8549L14.3212 17.457C14.3782 17.4919 14.4156 17.5483 14.4498 17.6035C14.5651 17.791 14.8513 18.2991 14.9107 18.491C14.988 18.7397 14.7781 18.9354 14.5235 18.8763Z"
      fill="white"
    />
    <path
      d="M5.54236 17.4216L3.96497 17.9625L3.48778 18.8188C3.26515 19.0214 2.89722 18.8109 2.98666 18.4692C3.0084 18.3854 3.48531 17.5224 3.53677 17.4798L5.33404 16.8549C5.68601 16.8013 5.8481 17.2328 5.54236 17.4216Z"
      fill="white"
    />
    <path
      d="M5.07865 14.7073C4.90143 14.7084 4.08411 14.5886 3.95394 14.5078L2.87905 13.3562C2.66027 13.0602 2.9894 12.6971 3.30229 12.906L4.27454 13.9545C4.51451 14.0705 5.20964 13.9935 5.35302 14.2109C5.50465 14.4413 5.35247 14.7056 5.07865 14.7073Z"
      fill="white"
    />
    <path
      d="M15.0271 13.3447L13.9032 14.5308C13.7956 14.5877 12.9574 14.7098 12.8118 14.707C12.5738 14.7026 12.4486 14.513 12.5011 14.2846C12.5724 13.9738 13.3776 14.0774 13.6156 13.9545L14.5884 12.9066C14.8757 12.6938 15.2258 13.0399 15.0271 13.3447Z"
      fill="white"
    />
    <path
      d="M12.0809 9.16358C12.0636 9.34442 11.9309 9.39142 11.7853 9.44748C11.391 9.59892 10.9614 9.66653 10.5693 9.82703C10.3623 10.0455 10.2195 10.9539 9.77287 10.7038C9.6383 10.6282 9.58739 10.4869 9.62427 10.3402C9.66252 10.1879 9.88515 9.7476 9.96716 9.58298C10.1182 9.28066 10.1392 9.31336 10.4443 9.20755C10.7479 9.10229 11.372 8.87555 11.6623 8.82993C11.8971 8.7931 12.1059 8.90111 12.0809 9.16358Z"
      fill="white"
    />
    <path
      d="M8.39306 10.5122C8.35921 10.7222 8.06696 10.8129 7.90102 10.6771C7.73563 10.5416 7.58152 9.90234 7.44007 9.81796C7.06223 9.67917 6.66045 9.59864 6.28234 9.4626C6.0897 9.39362 5.91936 9.3359 5.94743 9.08745C5.95926 8.98219 6.05063 8.85384 6.15768 8.8291C6.29225 8.79832 6.42214 8.85906 6.55093 8.89204C6.89794 8.98136 7.32944 9.11301 7.666 9.23504C7.99678 9.35486 7.96706 9.42275 8.11566 9.7204C8.21116 9.91168 8.42498 10.3154 8.39306 10.5122Z"
      fill="white"
    />
    <path
      d="M5.0495 16.2148H2.85099C2.48526 16.0686 2.56754 15.6104 2.96822 15.5903C3.0439 15.5865 3.10417 15.6145 3.17902 15.6137C3.79958 15.6077 4.42591 15.6123 5.0495 15.6134C5.37229 15.6629 5.36431 16.143 5.0495 16.2148Z"
      fill="white"
    />
    <path
      d="M15.0392 16.215H12.8407C12.601 16.1667 12.5182 15.8327 12.6962 15.6753C12.7458 15.6316 12.8275 15.6162 12.8927 15.6104C13.5691 15.5486 14.3515 15.6481 15.0389 15.6134C15.3593 15.7085 15.3549 16.1087 15.0392 16.215Z"
      fill="white"
    />
  </svg>
);

const CalenderIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.4 2.4H18V1.2C18 0.88174 17.8736 0.576515 17.6485 0.351472C17.4235 0.126428 17.1183 0 16.8 0C16.4817 0 16.1765 0.126428 15.9515 0.351472C15.7264 0.576515 15.6 0.88174 15.6 1.2V2.4H8.4V1.2C8.4 0.88174 8.27357 0.576515 8.04853 0.351472C7.82348 0.126428 7.51826 0 7.2 0C6.88174 0 6.57652 0.126428 6.35147 0.351472C6.12643 0.576515 6 0.88174 6 1.2V2.4H3.6C2.64522 2.4 1.72955 2.77928 1.05442 3.45442C0.379285 4.12955 0 5.04522 0 6V20.4C0 21.3548 0.379285 22.2705 1.05442 22.9456C1.72955 23.6207 2.64522 24 3.6 24H20.4C21.3548 24 22.2705 23.6207 22.9456 22.9456C23.6207 22.2705 24 21.3548 24 20.4V6C24 5.04522 23.6207 4.12955 22.9456 3.45442C22.2705 2.77928 21.3548 2.4 20.4 2.4ZM21.6 20.4C21.6 20.7183 21.4736 21.0235 21.2485 21.2485C21.0235 21.4736 20.7183 21.6 20.4 21.6H3.6C3.28174 21.6 2.97652 21.4736 2.75147 21.2485C2.52643 21.0235 2.4 20.7183 2.4 20.4V12H21.6V20.4ZM21.6 9.6H2.4V6C2.4 5.68174 2.52643 5.37652 2.75147 5.15147C2.97652 4.92643 3.28174 4.8 3.6 4.8H6V6C6 6.31826 6.12643 6.62348 6.35147 6.84853C6.57652 7.07357 6.88174 7.2 7.2 7.2C7.51826 7.2 7.82348 7.07357 8.04853 6.84853C8.27357 6.62348 8.4 6.31826 8.4 6V4.8H15.6V6C15.6 6.31826 15.7264 6.62348 15.9515 6.84853C16.1765 7.07357 16.4817 7.2 16.8 7.2C17.1183 7.2 17.4235 7.07357 17.6485 6.84853C17.8736 6.62348 18 6.31826 18 6V4.8H20.4C20.7183 4.8 21.0235 4.92643 21.2485 5.15147C21.4736 5.37652 21.6 5.68174 21.6 6V9.6Z"
      fill="white"
    />
  </svg>
);

const GridItem = ({ Icon, title, subtext, action }) => (
  <Box
    component="a"
    href={action}
    target="_blank"
    rel="noopener noreferrer"
    display="flex"
    flexDirection="row"
    alignItems="center"
    gap={"clamp(0.6vh, 0.6vw, 0.6vw)"}
    border="var(--bs-border-width) var(--bs-border-style) var(--bs-border-color)"
    borderRadius={"1vw"}
    padding={"clamp(0.6vh, 0.6vw, 0.6vw)"}
    width="100%"
    sx={{
      textDecoration: "none",
      color: "inherit",
      "&:hover": {
        backgroundColor: "rgba(0, 0, 0, 0.04)",
      },
      "& svg": {
        width: "clamp(2.5vh, 2.5vw, 2.5vw)",
        height: "clamp(2.5vh, 2.5vw, 2.5vw)",
        padding: "clamp(0.5vh, 0.5vw, 0.5vw)",
      },
    }}
  >
    <div
      style={{
        padding: "1px",
        backgroundColor: "#36357C",
        borderRadius: "50%",
      }}
    >
      <Icon />
    </div>
    <Box display="flex" flexDirection="column">
      <Typography
        sx={{ fontSize: "clamp(1.1vh, 1.1vw, 1.1vw)", width: "max-content" }}
      >
        {title}
      </Typography>
      <Typography sx={{ fontSize: "clamp(0.8vh, 0.8vw, 0.8vw)" }}>
        {subtext}
      </Typography>
    </Box>
  </Box>
);

const GridItem2 = ({ Icon, title, subtext, onClick }) => (
  <Box
    onClick={onClick}
    display="flex"
    flexDirection="row"
    alignItems="center"
    gap={"clamp(0.6vh, 0.6vw, 0.6vw)"}
    border="var(--bs-border-width) var(--bs-border-style) var(--bs-border-color)"
    borderRadius={"1vw"}
    padding={"clamp(0.6vh, 0.6vw, 0.6vw)"}
    width="100%"
    sx={{
      textDecoration: "none",
      color: "inherit",
      "&:hover": {
        backgroundColor: "rgba(0, 0, 0, 0.04)",
      },
      "& svg": {
        width: "clamp(2.5vh, 2.5vw, 2.5vw)",
        height: "clamp(2.5vh, 2.5vw, 2.5vw)",
        padding: "clamp(0.5vh, 0.5vw, 0.5vw)",
      },
      cursor: "pointer",
    }}
  >
    <div
      style={{
        padding: "1px",
        backgroundColor: "#36357C",
        borderRadius: "50%",
      }}
    >
      <Icon />
    </div>
    <Box display="flex" flexDirection="column">
      <Typography
        sx={{ fontSize: "clamp(1.1vh, 1.1vw, 1.1vw)", width: "max-content" }}
      >
        {title}
      </Typography>
      <Typography sx={{ fontSize: "clamp(0.8vh, 0.8vw, 0.8vw)" }}>
        {subtext}
      </Typography>
    </Box>
  </Box>
);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const GridLayout = ({ handleClose }) => {
  const reduxDispatch = useDispatch();
  const { isRecording } = useSelector((state) => state.recordingStatus);
  const { i18n } = useTranslation();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [ssoToken, setSsoToken] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingType, setLoadingType] = useState(null); // 'feature', 'bug', or null
  const [boardType, setBoardType] = useState('feature'); // 'feature' or 'bug'
  const tenantID = getTenantFromToken();

  const currentUser = useSelector((state) => state?.auth?.userData?.resource);
  const theme = useSelector((state) => state?.app?.theme);

  const user = useMemo(() => {
    if (!currentUser) return null;
    return {
      id: tenantID,
      name: currentUser.name,
      email: currentUser.email,
    };
  }, [currentUser]);

  const tabsList = [
    {
      value: "support",
      label: i18n.t("SUPPORT.SUPPORT"),
    },
    {
      value: "raise-ticket",
      label: i18n.t("SUPPORT.RAISE_TICKET"),
    },
  ];

  const [selectedTab, setSelectedTab] = useState(tabsList?.[0]);
  const [isCalendlyReady, setIsCalendlyReady] = useState(
    window?.Calendly && typeof window?.Calendly?.initPopupWidget === "function"
  );

  const items = [
    // { Icon: ChatIcon, title: "Chat", subtext: "Fastest Option", action: "#" },
    {
      Icon: CallIcon,
      title: "Call",
      subtext: "+1 (917)379-2638",
      action: "tel:+19173792638",
    },
    {
      Icon: TextIcon,
      title: "Text Message",
      subtext: "+1 (917)379-2638",
      action: "sms:+19173792638",
    },
    {
      Icon: WhatsappIcon,
      title: "WhatsApp",
      subtext: "+1 (917)379-2638",
      action: "https://wa.me/19173792638",
    },
    {
      Icon: EmailIcon,
      title: "Email",
      subtext: "support@noki.ai",
      action: "mailto:support@noki.ai",
    },
    // { Icon: CalenderIcon, title: "Scheduling a Meeting", subtext: "Book an appointment", action: "#" },
  ];

  const handleScheduling = () => {
    handleClose();

    const openCalendlyPopup = (url) => {
      if (isCalendlyReady) {
        window?.Calendly?.initPopupWidget({
          url: "https://cal.com/jaya-prakash-veerapaneni-v7yw8h/noki-demo?overlayCalendar=true",
        });
      }
    };

    if (isRecording) {
      reduxDispatch(set_show_popup(true, openCalendlyPopup));
    } else {
      openCalendlyPopup();
    }
  };

  const handleChat = () => {
    handleClose();
    document.getElementById("zsiq_agtpic").click();
  };

  const handleCannyWidget = async (type = 'feature') => {
    if (!user) return;

    setBoardType(type);
    setLoadingType(type);
    setLoading(true);

    try {
      const response = await HTTPAidaBaseService.get(
        `/canny/${tenantID}/generate-sso`
      );
      let token = response?.data?.ssoToken;
      if (token) {
        setSsoToken(token);
        setDialogOpen(true);
      } else {
        toast.error(`${i18n.t("error_messages.CANNY_TOAST_ERROR")}`);
      }
    } catch (error) {
      console.error("SSO token fetch error:", error);
    } finally {
      setLoading(false);
      setLoadingType(null);
    }
  };

  const handleFeatureRequest = () => {
    handleCannyWidget('feature');
  };

  const handleRaiseTicket = () => {
    handleCannyWidget('bug');
  };

  const supportOptions = [
    {
      fieldName: "consultWithUs",
      type: "contact",
      title: i18n.t("SUPPORT.CONSULT"),
      contents: [
        {
          iconName: "callIcon",
          title: i18n.t("SUPPORT.CALL"),
          icon: <CallIcon />,
          action: "tel:+15165507579",
          value: "+1 516 550 7579",
        },
        {
          iconName: "emailIcon",
          title: i18n.t("SUPPORT.EMAIL"),
          icon: <EmailIcon />,
          action: "mailto:support@noki.ai",
          value: "support@noki.ai",
        },
        {
          iconName: "chatBotIcon",
          title: i18n.t("SUPPORT.CHAT"),
          icon: <ChatBotIcon />,
          action: handleChat,
        },
      ],
    },
    // {
    //   fieldName: "writeToUsNow",
    //   type: "contact",
    //   title: i18n.t("SUPPORT.WRITE_TO_US_NOW"),
    //   contents: [
    //     // {
    //     //   iconName: "whatsappIcon",
    //     //   title: i18n.t("SUPPORT.WHATSAPP"),
    //     //   icon: <WhatsappIcon />,
    //     //   action: "https://wa.me/12898891279",
    //     //   value: "+1 289 889 1279",
    //     // },
    //     // {
    //     //   iconName: "textIcon",
    //     //   title: i18n.t("SUPPORT.TEXT"),
    //     //   icon: <TextIcon />,
    //     //   action: "sms:+15165507579",
    //     //   value: "+1 516 550 7579",
    //     //   disabled: true,
    //     // },
    //   ],
    // },
    {
      fieldName: "featureRequest",
      iconName: "featureReqIcon",
      title: i18n.t("SUPPORT.FEATURE_REQUEST"),
      icon: loadingType === 'feature' ? <CommonProgress /> : <FeatureReqIcon />,
      type: "SupportCard",
      action: handleFeatureRequest,
    },
    {
      fieldName: "raiseTicket",
      iconName: "raiseTicketIcon",
      title: i18n.t("SUPPORT.RAISE_TICKET"),
      icon: loadingType === 'bug' ? <CommonProgress /> : <RaiseTicketIcon />,
      type: "SupportCard",
      action: handleRaiseTicket,
    },
    {
      fieldName: "scheduleAMeeting",
      title: i18n.t("SUPPORT.SCHEDULE"),
      message: i18n.t("SUPPORT.MEETING_INFO"),
      type: "scheduling",
      image: CalendarSVG,
      action: handleScheduling,
    },
  ];

  return (
    <>
      <Box
        sx={{
          marginBottom: "1vw",
          textAlign: "center",
        }}
      >
        {/* <ToggleButtons
          tabsList={tabsList}
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
        /> */}

        <Dialog
          open={dialogOpen}
          onClose={() => setDialogOpen(false)}
          fullWidth
          maxWidth="md"
          sx={{
            "& .MuiDialog-paper": {
              background: theme === "dark" ? "#23224F" : "",
              display: "flex",
              flexDirection: "column",
              borderRadius: "24px",
              border: "2px solid #FFFFFF3D",
            },
          }}
          TransitionComponent={Transition}
        >
          <DialogTitle
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            <IconButton onClick={() => setDialogOpen(false)} sx={{ ml: 2 }}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ flex: 1, overflowY: "hidden", p: 3 }}>
            <CannyWidgetFR user={user} ssoToken={ssoToken} theme={theme} boardType={boardType} />
          </DialogContent>
        </Dialog>
      </Box>

      {selectedTab?.value === "support" ? (
        <SupportContents supportOptions={supportOptions} />
      ) : selectedTab?.value === "raise-ticket" ? (
        <SupportContactForm />
      ) : (
        <Box>Select one tab/button</Box>
      )}
    </>
  );
};

export default GridLayout;

const StyledToggleButtonGroup = styled(ToggleButtonGroup)({
  backgroundColor: "#2D2A48",
  borderRadius: "10vw", // Set outer container radius to 10vw for a round look
  padding: "5px", // Optional padding around buttons
  width: "70%",
});

const StyledToggleButton = styled(ToggleButton)(({ theme }) => ({
  color: theme === "dark" ? "#FFFFFF" : "#000",
  fontSize: "0.8vw",
  border: "none", // Remove default border
  textTransform: "none",
  borderRadius: "10vw", // Set border-radius to 10vw on each button,
  padding: "0.2vw",
  "&.MuiToggleButtonGroup-grouped:not(:last-of-type)": {
    borderTopRightRadius: "10vw", // Apply 10vw border radius on the right side of the first button
    borderBottomRightRadius: "10vw",
  },
  "&.MuiToggleButtonGroup-grouped:last-of-type": {
    borderTopLeftRadius: "10vw", // Apply 10vw border radius on the left side of the last button
    borderBottomLeftRadius: "10vw",
  },
  "&.Mui-selected": {
    backgroundColor: "#6E6BF8", // Color for selected state
    color: "#FFFFFF",
  },
  "&:not(.Mui-selected)": {
    backgroundColor: "transparent",
  },
}));

function ToggleButtons({
  setSelectedTab,
  selectedTab = tabsList?.[0],
  tabsList,
}) {
  const theme = useSelector((state) => state?.app?.theme);

  const handleToggle = (event, newSelection) => {
    if (newSelection !== null) {
      setSelectedTab(tabsList?.find((f) => f?.value === newSelection));
    }
  };

  return (
    <StyledToggleButtonGroup
      fullWidth
      value={selectedTab?.value}
      exclusive
      onChange={handleToggle}
      sx={{
        background: theme === "light" && "#F0F0F0",
      }}
    >
      {tabsList?.map((item, ind) => {
        return (
          <StyledToggleButton theme={theme} value={item?.value}>
            {item?.label}
          </StyledToggleButton>
        );
      })}
    </StyledToggleButtonGroup>
  );
}
